import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barra-paginacion',
  templateUrl: './barra-paginacion.component.html',
  styleUrls: ['./barra-paginacion.component.scss']
})
export class BarraPaginacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
